import createReduce from './_createReduce.js';

// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
export default createReduce(1);



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/reduce.js
// module id = 786
// module chunks = 0